export function withRecommendedLimits(draft, recommended) {
  if (!recommended) return draft;
  const limits = { ...draft.limits };
  for (const [name, value] of Object.entries(recommended)) {
    const current = limits[name];
    const absent = current == null || current === "" || (name !== "retries" && Number(current) === 0);
    if (absent) limits[name] = value;
  }
  return { ...draft, limits };
}

export function recommendedLimitLabel(name, value) {
  if (name === "amount") return `${value} USD`;
  if (name === "seconds") return `${value} с (${Number(value) / 60} мин)`;
  if (name === "documentBytes") return `${Number(value).toLocaleString("ru-RU")} байт (${Number(value) / (1 << 20)} МБ)`;
  return String(value);
}
